import { getInjectedProviderFromWindow } from '@dynamic-labs-sdk/client/core';

import type { BinanceBitcoinInjectedProvider } from '../BinanceBitcoinInjectedProvider.types';

const BINANCE_BITCOIN_PROVIDER_LOCATOR = 'binancew3w.bitcoin';

export const getBinanceBitcoinInjectedProvider = () => {
  return getInjectedProviderFromWindow<BinanceBitcoinInjectedProvider>(
    BINANCE_BITCOIN_PROVIDER_LOCATOR
  );
};
